import { render, staticRenderFns } from "./TestimonialTwo.vue?vue&type=template&id=cfb6a684&scoped=true"
import script from "./TestimonialTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb6a684",
  null
  
)

export default component.exports